import { createContext } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export interface Toast {
  id: number;
  type: ToastType;
  message: string;
  /** Present on "step complete" toasts — larger card with a clickable next-step link. */
  step?: {
    /** Longer body text (the `message` is the title for step toasts). */
    body?: string;
    /** Where "→ next step" navigates when clicked. */
    href?: string;
    /** Label for the next-step link. Defaults to "Continue". */
    nextLabel?: string;
  };
}

export interface StepToastOpts {
  /** Additional body text under the title. */
  body?: string;
  /** URL to navigate to when the user clicks "→ next step". */
  href?: string;
  /** Label for the next-step link. */
  nextLabel?: string;
  /** Also fires a browser (system) notification when permission is granted. Default true. */
  browserNotification?: boolean;
  /** Groups repeat step notifications so a second one replaces the first. */
  tag?: string;
}

export interface ToastContextValue {
  push: (message: string, type?: ToastType) => void;
  /**
   * Larger toast for workflow step transitions ("process complete → next step").
   * When browserNotification is not disabled, also fires a system notification.
   */
  pushStep: (title: string, opts?: StepToastOpts) => void;
}

export const ToastContext = createContext<ToastContextValue | undefined>(undefined);
